/** Traductions modale gestion des factures (FR / AR) */
export const invoiceManagementModalFr = {
  title: 'Gestion des Factures',
  createInvoices: 'Créer Factures',
  creating: 'Création...',
  reset: 'Réinitialiser',
  search: 'Rechercher...',
  allSuppliers: 'Tous les Fournisseurs',
  allStatuses: 'Tous les Statuts',
  pending: 'En Attente',
  partial: 'Partiel',
  paid: 'Payé',
  all: 'Tout',
  normal: 'Normal',
  consolidated: 'Consolidé',
  purchase: 'Achat',
  order: 'Commande',
  nInvoice: 'N° Facture',
  type: 'Type',
  supplier: 'Fournisseur',
  supplierInfo: 'Informations Fournisseur',
  supplierNameLabel: 'Nom',
  supplierAddress: 'Adresse',
  supplierPhone: 'Téléphone',
  invoiceDocTitle: 'FACTURE',
  dateLabel: 'Date',
  total: 'Total',
  paidCol: 'Payé',
  remaining: 'Restant',
  status: 'Statut',
  actions: 'Actions',
  view: 'Voir',
  pay: 'Payer',
  delete: 'Supprimer',
  paymentTitle: 'Enregistrer Paiement',
  deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette facture?',
  invoiceDeleted: 'Facture supprimée avec succès',
  invoiceLabel: 'Facture:',
  supplierLabel: 'Fournisseur:',
  totalAmount: 'Montant Total:',
  paidAmount: 'Montant Payé:',
  remainingAmount: 'Montant Restant:',
  paymentAmount: 'Montant du Paiement:',
  paymentMethod: 'Méthode de Paiement:',
  cancel: 'Annuler',
  savePayment: 'Enregistrer Paiement',
  paymentRecorded: 'Paiement enregistré',
  filtersReset: 'Filtres réinitialisés',
  facturesCreated: 'factures créées',
  createError: 'Erreur lors de la création des factures',
  paying: 'Traitement...',
  sourceInvoices: 'Factures incluses',
  sourceInvoicesShort: 'Incl.',
  consolidatedIncludes: 'Détail des factures consolidées',
  paymentHistory: 'Historique des paiements',
  noPayments: 'Aucun paiement enregistré',
  clickRowHint: 'Cliquez sur une ligne pour voir l\'historique',
  paymentFull: 'Paiement complet',
  paymentPartial: 'Paiement partiel',
  allocationFifo: 'Répartition automatique (plus ancienne d\'abord)',
  allocationFifoHint: 'Le montant est déduit automatiquement de la facture ouverte la plus ancienne',
  allocationTarget: 'Payer une facture spécifique',
  allocationTargetHint: 'Choisissez une facture source dans le groupe consolidé',
  selectSourceInvoice: 'Choisir la facture',
  colDate: 'Date',
  changeInvoice: 'Changer de facture',
  fullBalance: 'Solde',
  moreOptions: 'Plus d\'options',
  payNow: 'Enregistrer le paiement',
  noNewTransactions: 'Aucune nouvelle transaction à facturer',
  reportTitle: 'Rapport de Gestion des Factures',
  exportColInvoiceNumber: 'N° Facture',
  exportColType: 'Type',
  exportColSupplier: 'Fournisseur',
  exportColTotalAmount: 'Montant Total',
  exportColPaidAmount: 'Montant Payé',
  exportColRemainingAmount: 'Montant Restant',
  exportColStatus: 'Statut',
  summaryTotalInvoices: 'Total Factures',
  summaryTotalAmount: 'Total Montant',
  summaryRemainingAmount: 'Total Restant',
  removeConsolidation: 'Retirer consolidation',
  removeConsolidationConfirm:
    'Retirer cette facture consolidée ? Les factures d’achat (enfants) restent. S’il reste ≥2 factures ouvertes, une seule consolidation peut être recréée.',
  consolidationRemoved: 'Consolidation retirée',
};

export const invoiceManagementModalAr = {
  title: 'إدارة الفواتير',
  createInvoices: 'إنشاء الفواتير',
  creating: 'جاري الإنشاء...',
  reset: 'إعادة تعيين',
  search: 'البحث...',
  allSuppliers: 'جميع الموردين',
  allStatuses: 'جميع الحالات',
  pending: 'معلق',
  partial: 'جزئي',
  paid: 'مدفوع',
  all: 'الكل',
  normal: 'عادي',
  consolidated: 'مدمج',
  purchase: 'شراء',
  order: 'طلب',
  nInvoice: 'رقم الفاتورة',
  type: 'نوع الفاتورة',
  supplier: 'المورد',
  supplierInfo: 'معلومات المورد',
  supplierNameLabel: 'الاسم',
  supplierAddress: 'العنوان',
  supplierPhone: 'الهاتف',
  invoiceDocTitle: 'فاتورة',
  dateLabel: 'التاريخ',
  total: 'المجموع',
  paidCol: 'المدفوع',
  remaining: 'المتبقي',
  status: 'الحالة',
  actions: 'الإجراءات',
  view: 'عرض',
  pay: 'دفع',
  delete: 'حذف',
  paymentTitle: 'تسجيل الدفع',
  deleteConfirm: 'هل أنت متأكد من حذف هذه الفاتورة؟',
  invoiceDeleted: 'تم حذف الفاتورة بنجاح',
  invoiceLabel: 'الفاتورة:',
  supplierLabel: 'المورد:',
  totalAmount: 'المبلغ الإجمالي:',
  paidAmount: 'المبلغ المدفوع:',
  remainingAmount: 'المبلغ المتبقي:',
  paymentAmount: 'مبلغ الدفع:',
  paymentMethod: 'طريقة الدفع:',
  cancel: 'إلغاء',
  savePayment: 'تسجيل الدفع',
  paymentRecorded: 'تم تسجيل الدفع',
  filtersReset: 'تمت إعادة تعيين الفلاتر',
  facturesCreated: 'فواتير تم إنشاؤها',
  createError: 'خطأ أثناء إنشاء الفواتير',
  paying: 'جاري المعالجة...',
  sourceInvoices: 'الفواتير المدمجة',
  sourceInvoicesShort: 'يشمل',
  consolidatedIncludes: 'تفاصيل الفواتير المدمجة',
  paymentHistory: 'سجل المدفوعات',
  noPayments: 'لا توجد مدفوعات مسجلة',
  clickRowHint: 'انقر على الصف لعرض سجل المدفوعات',
  paymentFull: 'دفع كامل',
  paymentPartial: 'دفع جزئي',
  allocationFifo: 'توزيع تلقائي (الأقدم أولاً)',
  allocationFifoHint: 'يُخصم المبلغ تلقائياً من أقدم فاتورة غير مدفوعة',
  allocationTarget: 'دفع فاتورة محددة',
  allocationTargetHint: 'اختر فاتورة واحدة داخل المجموعة المدمجة',
  selectSourceInvoice: 'اختر الفاتورة',
  colDate: 'التاريخ',
  changeInvoice: 'تغيير الفاتورة',
  fullBalance: 'الكامل',
  moreOptions: 'خيارات إضافية',
  payNow: 'تسجيل الدفع',
  noNewTransactions: 'لا توجد معاملات جديدة لإنشاء فواتير',
  reportTitle: 'تقرير إدارة الفواتير',
  exportColInvoiceNumber: 'رقم الفاتورة',
  exportColType: 'النوع',
  exportColSupplier: 'المورد',
  exportColTotalAmount: 'المبلغ الإجمالي',
  exportColPaidAmount: 'المبلغ المدفوع',
  exportColRemainingAmount: 'المبلغ المتبقي',
  exportColStatus: 'الحالة',
  summaryTotalInvoices: 'إجمالي الفواتير',
  summaryTotalAmount: 'المبلغ الإجمالي',
  summaryRemainingAmount: 'المبلغ المتبقي',
  removeConsolidation: 'إزالة الدمج',
  removeConsolidationConfirm:
    'إزالة هذه الفاتورة المدمجة؟ فواتير الشراء (الفرعية) تبقى. إذا بقيت ≥2 فواتير مفتوحة قد تُعاد Consolidation واحدة.',
  consolidationRemoved: 'تم إزالة الدمج',
};
